export const generateSliderSteps = (start: number, end: number, step?: number): number[] => {
  // If step is undefined, just return [start, end]
  if (step === undefined) {
    return [start, end];
  }

  const result: number[] = [start];

  let current = start + (step - (start % step));

  if (start % step === 0) {
    current = start + step;
  }

  while (current < end) {
    result.push(current);
    current += step;
  }

  if (result[result.length - 1] !== end) {
    result.push(end);
  }

  return result;
};
